export default __webpack_public_path__ + "static/media/fink-vertical.b691f3a1.png";